


















































import { Component, Prop, Vue } from 'vue-property-decorator';

import KeypadVue from './Keypad.vue';
import CombinationLockVue from './CombinationLock.vue';
import WirecutVue from './Wirecut.vue';


@Component({
    components: {
        KeypadVue,
        CombinationLockVue,
        WirecutVue,
    },
})
export default class PuzzleTestVue extends Vue {

    keypad2_layout = [["A",'B','C','D','E'],['X','Y','Z','','clear']];

    mounted(){



    }

}

